<template>
  <v-form>
    <v-container>
      <v-row 
       
       v-if="value.newOrExisting == 'existing' && value.existingMh1PracticeId">
        <v-col cols="12" align-self="baseline">
          <v-alert type="info">
            Manage Practice in MH1
            <v-btn icon :href="mh1PracticeShowUrl + value.existingMh1PracticeId" target="_blank">
              <v-icon  x-small class="pl-1 mt-n1">mdi-open-in-new</v-icon>
            </v-btn>
          </v-alert>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <h5>{{mh1ColumnHeader}}</h5>
        </v-col>
        <v-col cols="4">
          <h5>Value Read from PMS Site</h5>
        </v-col>
      </v-row>
      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field
            :disabled="mh1InputDisabled"
            required
            :rules="practiceNameRules"
            label="Practice Name"
            v-model="practiceDetails.name"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <span>{{selectedSite.name}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-select
            :disabled="mh1InputDisabled"
            required
            :rules="[v => !!v || 'Practice Type is required']"
            label="Practice Type"
            :items="mh1ServiceTypes"
            v-model="practiceDetails.type"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <span>{{practiceType}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-select
            :disabled="mh1InputDisabled"
            label="Practice Group"
            :items="mh1PracticeGroups"
            v-model="practiceDetails.practiceGroup"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <span></span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field :disabled="mh1InputDisabled" label="Phone" v-model="practiceDetails.phone"></v-text-field>
        </v-col>
        <v-col cols="4">
          <span>{{selectedSite.publicContactPhone || selectedSite.siteSupportContactPhone}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field :disabled="mh1InputDisabled" label="Email" v-model="practiceDetails.email"></v-text-field>
        </v-col>
        <v-col cols="4">
          <span>{{selectedSite.publicContactEmail || selectedSite.siteSupportContactEmail}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field
            :disabled="mh1InputDisabled"
            label="Website URL"
            v-model="practiceDetails.website"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <span>{{selectedSite.website}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <h4>Address</h4>
        </v-col>
      </v-row>
      <v-row align="baseline">
        <v-col cols="8">
          <h5>MH1 Practice Input Value</h5>
        </v-col>
        <v-col cols="4">
          <h5>Value Read from PMS Site</h5>
        </v-col>
      </v-row>
      <v-row align="baseline">
        <v-col cols="8">
          <v-select
            :disabled="mh1InputDisabled"
            :items="countries"
            label="Country"
            item-text="name"
            item-value="name"
            v-model="practiceDetails.country"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <span>{{(selectedSite.address || {}).country}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-select
            :disabled="mh1InputDisabled"
            :items="states"
            label="State"
            v-model="practiceDetails.state"
            item-text="name"
            item-value="name"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <span>{{(selectedSite.address || {}).state}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field
            :disabled="mh1InputDisabled"
            required
            :rules="[v => !!v || 'Address is required']"
            label="Address Line 1"
            v-model="practiceDetails.addressLine1"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <span>{{(selectedSite.address || {}).addressLine1}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field
            :disabled="mh1InputDisabled"
            label="Address Line 2"
            v-model="practiceDetails.addressLine2"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <span>{{(selectedSite.address || {}).addressLine2}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field
            :disabled="mh1InputDisabled"
            label="Postcode"
            v-model="practiceDetails.postcode"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <span>{{(selectedSite.address || {}).postcode}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field :disabled="mh1InputDisabled" label="City" v-model="practiceDetails.city"></v-text-field>
        </v-col>
        <v-col cols="4">
          <span>{{(selectedSite.address || {}).city}}</span>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>

      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field
            :disabled="mh1InputDisabled"
            label="Longitude"
            v-model="practiceDetails.longitude"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <span v-if="googleMapsSearchLink">
            Google Map Search
            <v-btn
              icon
              :href="'https://www.google.com/maps/search/' + encodeURI(googleMapsSearchLink)"
              target="_blank"
            >
              <v-icon  x-small class="pl-1 mt-n1">mdi-open-in-new</v-icon>
            </v-btn>
          </span>
          <span>{{(selectedSite.address || {}).longitude}}</span>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-text-field
            :disabled="mh1InputDisabled"
            label="Latitude"
            v-model="practiceDetails.latitude"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <span>{{(selectedSite.address || {}).latitude}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <h4>Integration Settings</h4>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-select
            required
            :rules="[v => !!v || 'PMS Type is required']"
            label="PMS Type"
            :items="pmsTypes"
            v-model="practiceDetails.pms"
            item-text="name"
            item-value="id"
            :disabled="true"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <span>{{getPmsType.name || ""}}</span>
        </v-col>
      </v-row>
      <v-row align="baseline">
        <v-col cols="8">
          <v-switch
            :disabled="mh1InputDisabled"
            label="Real-Time Bookings Enabled"
            v-model="practiceDetails.rtbEnabled"
          ></v-switch>
        </v-col>
        <v-col cols="4">
          <span></span>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="6" align-self="baseline">
          <v-slider
            v-model="practiceDetails.rtbTimeout"
            :min="5"
            :max="60"
            label="Real-Time Bookings Timeout"
            :disabled="mh1InputDisabled || !practiceDetails.rtbEnabled"
          ></v-slider>
        </v-col>
        <v-col cols="3" align-self="baseline">
          <v-text-field
            v-model="practiceDetails.rtbTimeout"
            hide-details
            type="number"
            style="width: 60px"
            label="seconds"
            :disabled="mh1InputDisabled || !practiceDetails.rtbEnabled"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <h4>Opening Hours</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-simple-table>
            <template>
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Open</th>
                  <th>Start Hour</th>
                  <th>End Hour</th>
                  <th>PMS Data</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(day,index) in ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']"
                  :key="index"
                >
                  <td>{{day}}</td>
                  <td>
                    <v-switch
                      :disabled="mh1InputDisabled"
                      v-model="practiceDetails.openingHours[day.toLowerCase()].open"
                    ></v-switch>
                  </td>
                  <td>
                    <vue-timepicker
                      :disabled="mh1InputDisabled || !practiceDetails.openingHours[day.toLowerCase()].open"
                      format="h:mm A"
                      :minute-interval="5"
                      v-model="practiceDetails.openingHours[day.toLowerCase()].start"
                    ></vue-timepicker>
                  </td>
                  <td>
                    <vue-timepicker
                      :disabled="mh1InputDisabled || !practiceDetails.openingHours[day.toLowerCase()].open"
                      format="h:mm A"
                      :minute-interval="5"
                      v-model="practiceDetails.openingHours[day.toLowerCase()].end"
                    ></vue-timepicker>
                  </td>
                  <td>
                    <span
                      v-if="selectedSite.openingHours && selectedSite.openingHours.weeklySchedule[day.toLowerCase()]"
                    >{{getSiteStartHourForDay(day.toLowerCase())}} - {{getSiteEndHourForDay(day.toLowerCase())}}</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";
import VueTimepicker from "vue2-timepicker";
import PmsTypes from "@/assets/mh1PmsTypes.json";

// CSS
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  name: "PracticeDetails",
  props: {
    value: Object,
    index: Number,
    pmsInfo: Object,
  },
  components: { VueTimepicker },
  created: async function () {
    // this is always valid as one feature has to be selected
    this.pmsTypes = PmsTypes.items;
    this.$emit("step-is-valid", 1);
    await this.getServiceTypes();
  },
  data: function () {
    return {
      mh1PracticeShowUrl: process.env.VUE_APP_MH1_BASE_URI + "/practice/show/",
      practiceNameRules: [(v) => !!v || "Practice Name is required"],
      practiceDetails: {
        name: "",
        type: "",
        phone: "",
        website: "",
        practiceGroup: "",
        country: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        postcode: "",
        rtbEnabled: true,
        rtbTimeout: 10,
        pms: "",
        openingHours: {
          monday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          tuesday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          wednesday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          thursday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          friday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          saturday: {
            open: false,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          sunday: {
            open: false,
            start: "9:00 AM",
            end: "5:00 PM",
          },
        },
      },
      countries: [
        {
          name: "Australia",
          states: [
            { abbreviation: "NSW", name: "New South Wales" },
            { abbreviation: "VIC", name: "Victoria" },
            { abbreviation: "QLD", name: "Queensland" },
            { abbreviation: "WA", name: "Western Australia" },
            { abbreviation: "SA", name: "South Australia" },
            { abbreviation: "NT", name: "Nothern Territory" },
            { abbreviation: "TAS", name: "Tasmania" },
            { abbreviation: "ACT", name: "Australian Capital Territory" },
          ],
        },
        {
          name: "New Zealand",
          states: [],
        },
      ],
      mh1ServiceTypes: [],
      mh1PracticeGroups: [],
      isLoading: false,
      googleMapsSearchLink: "",
      pmsTypes: [],
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      if (
        newVal.newOrExisting == "existing" &&
        newVal.existingMh1PracticeId != oldVal.existingMh1PracticeId
      ) {
        const mh1Prac = newVal.existingMh1Practice;

        if (!mh1Prac) {
          return;
        }

        this.practiceDetails.name = mh1Prac.name;

        this.practiceDetails.email = mh1Prac.email;
        this.practiceDetails.phone = mh1Prac.phone;

        this.practiceDetails.country = mh1Prac.country ?? "Australia";

        //this.practiceDetails.state = mh1Prac.state;
        if (mh1Prac.state) {
          const mh1State = mh1Prac.state?.trim()?.toLowerCase();

          const foundState = this.countries
            ?.find((c) => c.name == this.practiceDetails.country)
            ?.states?.find(
              (s) =>
                s?.name?.trim()?.toLowerCase() == mh1State ||
                s?.abbreviation?.trim()?.toLowerCase() == mh1State
            );
          if (foundState?.name) {
            this.practiceDetails.state = foundState.name;
          }
        }

        this.practiceDetails.addressLine1 = mh1Prac.address1;
        this.practiceDetails.addressLine2 = mh1Prac.address2;
        this.practiceDetails.city = mh1Prac.city;
        this.practiceDetails.postcode = mh1Prac.postcode;

        this.practiceDetails.latitude = mh1Prac.latitude;
        this.practiceDetails.longitude = mh1Prac.longitude;

        console.log("mh1Prac.pms", mh1Prac.pms);
        this.practiceDetails.pms = mh1Prac.pms?.id
          ? Number(mh1Prac.pms.id)
          : ""; // id name
        console.log("mh1Prac.pms set", this.practiceDetails.pms);

        this.practiceDetails.type = mh1Prac.serviceType?.id ?? ""; // id name
      } else if (
        newVal.newOrExisting == "new" &&
        newVal.selectedSiteId != oldVal.selectedSiteId
      ) {
        const newSite =
          this.pmsInfo.sites?.find(
            (s) => s.pmsSiteId == this.value.selectedSiteId
          ) ?? {};
        if (newSite) {
          this.practiceDetails.name = newSite.name;

          const thisCountry =
            newSite.address?.country?.englishShortName ?? "Australia";
          this.practiceDetails.country = thisCountry;

          if (newSite.address?.state) {
            const newSiteState = newSite.address?.state?.trim()?.toLowerCase();

            const foundState = this.countries
              ?.find((c) => c.name == thisCountry)
              ?.states?.find(
                (s) =>
                  s?.name?.trim()?.toLowerCase() == newSiteState ||
                  s?.abbreviation?.trim()?.toLowerCase() == newSiteState
              );
            if (foundState) {
              this.practiceDetails.state = foundState.name;
            }
          }

          const foundType = this.mh1ServiceTypes?.find(
            (t) =>
              t.name?.trim()?.toLowerCase() ==
              this.practiceType?.trim()?.toLowerCase()
          );
          if (foundType) {
            this.practiceDetails.type = foundType.id;
          }

          this.practiceDetails.addressLine1 = newSite.address?.addressLine1;
          this.practiceDetails.addressLine2 = newSite.address?.addressLine2;
          this.practiceDetails.city = newSite.address?.city;
          this.practiceDetails.postcode = newSite.address?.postcode;

          this.practiceDetails.phone =
            newSite.publicContactPhone || newSite.siteSupportContactPhone;
          this.practiceDetails.email =
            newSite.publicContactEmail || newSite.siteSupportContactEmail;
          this.practiceDetails.website = newSite.website;

          this.practiceDetails.pms = this.getPmsType?.id;

          const mapSearchItems = [
            newSite.name,
            newSite.address?.addressLine1,
            newSite.address?.addressLine2,
            newSite.address?.city,
            newSite.address?.postcode,
            newSite.address?.state,
            newSite.address?.country,
          ];
          console.log(
            "mapSearchItems",
            mapSearchItems,
            mapSearchItems.filter((a) => a),
            mapSearchItems.filter((a) => a).join(", ")
          );

          this.googleMapsSearchLink = mapSearchItems
            .filter((a) => a)
            .join(", ");

          if (newSite.openingHours?.weeklySchedule) {
            for (const day of [
              "monday",
              "tuesday",
              "wednesday",
              "thursday",
              "friday",
              "saturday",
              "sunday",
            ]) {
              if (
                !newSite.openingHours.weeklySchedule[day] ||
                newSite.openingHours.weeklySchedule[day].length == 0
              ) {
                this.practiceDetails.openingHours[day].open = false;
              } else {
                const dayData = newSite.openingHours.weeklySchedule[day];

                const start24 = dayData.map((d) => d.start).sort()[0];
                const end24 = dayData
                  .map((d) => d.end)
                  .sort()
                  .reverse()[0];
                const start12 = new Date(
                  "2000-01-01T" + start24
                ).toLocaleString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                });
                const end12 = new Date("2000-01-01T" + end24).toLocaleString(
                  "en-US",
                  {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                  }
                );

                this.practiceDetails.openingHours[day].open = true;
                this.practiceDetails.openingHours[day].start = start12;
                this.practiceDetails.openingHours[day].end = end12;
              }
            }
          }
        }
      }
    },
  },
  computed: {
    mh1InputDisabled: function () {
      return this.value.newOrExisting != "new" ? true : false;
    },
    mh1ColumnHeader: function () {
      return this.value.newOrExisting == "new"
        ? "MH1 Practice Input Value"
        : "Current MH1 Practice Value";
    },
    states: function () {
      return (
        this.countries?.find((c) => c.name == this.practiceDetails?.country)
          ?.states ?? []
      );
    },
    selectedSite: function () {
      return (
        this.pmsInfo.sites?.find(
          (s) => s.pmsSiteId == this.value.selectedSiteId
        ) ?? {}
      );
    },
    practiceType: function () {
      switch (this.pmsInfo?.pmsType?.toLowerCase() ?? "") {
        case "optomatetouch":
        case "optomatepremier":
        case "sunix": {
          return "Optometrist";
          break;
        }
        default: {
          return "Doctor";
        }
      }
    },
    getPmsType: function () {
      return this.pmsTypes.find((p) => {
        if (p.code && p.code == this.getPmsTypeCode) return p;

        const name = p?.name?.toLowerCase().replace(" ", "") ?? "";

        if (name && name == this.getPmsTypeCode) return p;
      });
    },
    getPmsTypeCode: function () {
      return (this.pmsInfo.pmsType || "")?.toLowerCase() ?? "";
    },
  },
  methods: {
    async getServiceTypes() {
      console.log("getservicetypes called");
      const getMh1ServiceTypesNarrow = /* GraphQL */ `
        query GetMh1ServiceTypes {
          getMh1ServiceTypes {
            id
            name
            orderBy
          }
        }
      `;

      this.isLoading = true;
      try {
        const searchResult = await API.graphql(
          graphqlOperation(getMh1ServiceTypesNarrow)
        );

        console.log("getServiceTypes got", searchResult);

        if (!searchResult?.data?.getMh1ServiceTypes) {
          console.log("did not get results", searchResult);
          this.mh1ServiceTypes = [];
          return;
        }

        this.mh1ServiceTypes =
          searchResult.data.getMh1ServiceTypes?.sort((s) => s.orderBy) ?? [];
      } catch (err) {
        console.log("getServiceTypes err", err);
      } finally {
        this.isLoading = false;
      }
    },
    getSiteStartHourForDay: function (day) {
      const start24 =
        this.selectedSite.openingHours?.weeklySchedule[day.toLowerCase()]
          ?.map((d) => d.start)
          ?.sort()[0] || "";
      if (start24 == "") {
        return "";
      }
      return new Date("2000-01-01T" + start24).toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    },
    getSiteEndHourForDay: function (day) {
      const end24 =
        this.selectedSite.openingHours?.weeklySchedule[day.toLowerCase()]
          ?.map((d) => d.end)
          ?.sort()
          ?.reverse()[0] || "";
      if (end24 == "") {
        return "";
      }
      return new Date("2000-01-01T" + end24).toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    },
  },
};
</script>